import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import BlockFillingHero from './components/BlockFillingHero';
import ServiceFeatures from './components/ServiceFeatures';
import ProcessSteps from './components/ProcessSteps';
import QuoteForm from './components/QuoteForm';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lgconcretepumping.com';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  '@id': `${SITE_URL}/services/block-filling#service`,
  name: 'Block Filling Services',
  url: `${SITE_URL}/services/block-filling`,
  description:
    'Precision block filling services for structural integrity and durability in residential and commercial construction in Western NC.',
  provider: { '@id': `${SITE_URL}/#business` },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Western North Carolina' },
    { '@type': 'AdministrativeArea', name: 'North Georgia' },
    { '@type': 'AdministrativeArea', name: 'Southwest South Carolina' },
  ],
  serviceType: 'Block Filling',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Block Filling Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Residential Block Filling' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Commercial Block Filling' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Structural Block Core Fill' } },
    ],
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_URL}/services` },
    { '@type': 'ListItem', position: 3, name: 'Block Filling', item: `${SITE_URL}/services/block-filling` },
  ],
};

const BlockFillingPage = () => {
  useEffect(() => {
    const scripts: HTMLScriptElement[] = [];
    [serviceSchema, breadcrumbSchema].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Block Filling Services | LG Concrete Pumping & Stone LLC Otto NC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Precision block filling for structural integrity in residential and commercial construction. LG Concrete Pumping & Stone LLC, Otto NC. Call (828) 634-1304.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${SITE_URL}/services/block-filling`);

    return () => { scripts.forEach((s) => s.remove()); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <BlockFillingHero />
        <ServiceFeatures />
        <ProcessSteps />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
};

export default BlockFillingPage;
